import React from "react";
 // Maintenance mode page
const Maintenance = () => {
    const message =
        sessionStorage.getItem("maintenanceMessage") ||
        "L'application est actuellement en maintenance. Merci de réessayer dans quelques instants.";

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="card border-0 shadow-sm text-center p-4 p-md-5">

                            <div
                                className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10"
                                style={{ width: "80px", height: "80px" }}
                            >
                                <span style={{ fontSize: "38px" }}>🔧</span>
                            </div>

                            <h1 className="h3 fw-semibold mb-3">
                                Application en maintenance
                            </h1>

                            <p className="text-muted mb-0">
                                {message}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;